import React, { useEffect, useState } from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'
import { UserService } from '@/api/user'
import { useFetch } from '@/hooks/useFetch'
import { Loading } from '@/components/ui/Loading'

export const KpiLeadership: React.FC = () => {
  const { data: userData, isLoading: isLoadingProfile } = UserService.useGetProfile()
  const {
    data: urlMetabase,
  } = useFetch({
    path: '/api/v1/metabase?dashboard=98&filter[fullname_tim]=' + userData?.fullname,
  })

  const [url, setUrl] = useState<string>(env.iFrameMetabaseKpiLeadership)

  useEffect(() => {
    const role = userData?.role?.toLowerCase()

    if(role?.includes('manager') || role?.includes('staff hr')) {
      const fullnameTim = userData?.fullname?.replace(/\s+/g, '+')
      const newUrl = `${env.iFrameMetabaseKpiLeadership}?fullname_tim=${fullnameTim}`

      setUrl(newUrl)
    } else {
      // @ts-ignore
      setUrl(urlMetabase)
    }
  }, [userData, urlMetabase])

  if (isLoadingProfile) return <Loading />

  return (
    <Section title="Dashboard KPI Leadership">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          data-testid="dashboard-iframe"
          title="KPI Leadership"
          src={url}
          width="100%"
          height="600"
          style={{ border: 'none' }}
        />
      </div>
    </Section>
  )
}
